module.exports = __webpack_public_path__ + "static/media/White sweater and two tone pant.34dd0949.jpg";